import React from 'react'

import { BusinessEventIcon } from '../../../../../../../components/BusinessEvent/BusinessEventIcon/BusinessEventIcon'

import { AiResult } from '../../../../../../../models/AiResult'
import { AiFeature } from '../../../../../../../models/AiFeature'

import { selectBusinessEventsForAiFeatureId } from '../../../../../../../store/businessEvent/businessEvent'
import { useAppSelector } from '../../../../../../../store/hooks'

import { TrackEvent, useTracking } from '../../../../common/tracking'

import { CUSTOM_PRESET_MAPPING } from '../../../CustomPresets/CustomPresetMapping'
import { getRoomTrackingDetailsForAiResult } from '../../../../tracking'

import { HeaderResultOptionConfig } from './HeaderResultOptions/DefaultHeaderResultOptions'
import { HeaderResultOption } from './HeaderResultOptions/HeaderResultOptionsButton'
import { DefaultResultCardHeaderButtons } from './ResultCardHeaderButtons'

export interface ResultCardHeaderProps {
  presetId: string
  name: string
  aiFeature?: AiFeature
  aiResult?: AiResult
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
  noResults: boolean
  extraHeaderOptions?: HeaderResultOption[]
  headerResultOptionsConfig?: Partial<HeaderResultOptionConfig>
  showBusinessEvents?: boolean
}

export const ResultCardHeader: React.FC<ResultCardHeaderProps> = ({
  presetId,
  name,
  aiFeature,
  aiResult,
  collapsed,
  setCollapsed,
  noResults,
  extraHeaderOptions,
  headerResultOptionsConfig,
  showBusinessEvents = false,
}) => {
  const { tracked } = useTracking()

  const businessEvents = useAppSelector((state) => (aiFeature ? selectBusinessEventsForAiFeatureId(state, aiFeature.id) : []))

  const _handleHeaderClicked = () => {
    if (!noResults && !aiResult) {
      return
    }
    setCollapsed(!collapsed)
  }

  const handleHeaderClicked = tracked(
    _handleHeaderClicked,
    {
      eventName: TrackEvent.AI_RESULT_OPENED,
      eventDetails: {
        ...getRoomTrackingDetailsForAiResult(aiResult),
        openMethod: 'single',
      },
    },
    { condition: collapsed },
  )

  const ResultCardHeaderButtonsElement = CUSTOM_PRESET_MAPPING[presetId]?.headerButtons ?? DefaultResultCardHeaderButtons

  return (
    <div className='d-flex gap-3 zocks-pr-1.75 zocks-pl-2.0 align-items-center result-card-header'>
      <div className='d-flex gap-3 flex-grow-1 align-items-center cursor-pointer' onClick={handleHeaderClicked}>
        <h5 className='flex-grow-1'>{name}</h5>
        {showBusinessEvents && businessEvents.length ? (
          <div className='d-flex align-items-center gap-1'>
            <BusinessEventIcon />
            <span className='lead-small'>{businessEvents.length}</span>
          </div>
        ) : null}
      </div>
      {aiFeature && aiResult && (
        <div className='result-card-buttons-container'>
          <ResultCardHeaderButtonsElement
            aiFeature={aiFeature}
            aiResult={aiResult}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            noResults={noResults}
            extraHeaderOptions={extraHeaderOptions}
            headerResultOptionsConfig={headerResultOptionsConfig}
          />
        </div>
      )}
    </div>
  )
}
